import { Spinner } from '@shared/components/spinner';
import * as React from 'react';

export const Fallback = () => (
    <div
        style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#ffffff'
        }}
    >
        <Spinner />
    </div>
);
